import { render, staticRenderFns } from "./config.vue?vue&type=template&id=3b4fcd37&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=3b4fcd37&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4fcd37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4fcd37')) {
      api.createRecord('3b4fcd37', component.options)
    } else {
      api.reload('3b4fcd37', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=3b4fcd37&scoped=true", function () {
      api.rerender('3b4fcd37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backend/config.vue"
export default component.exports